// sometimes, a conversion function will have an optional field. this replaces
// field: field ? convertIFieldResponseToIFieldData(field) : undefined;
export function undefConversion<Response, Data>(conversionFunction: (response: Response) => Data, attr?: Response) {
  if (attr !== undefined) return conversionFunction(attr);
  return undefined;
}

export function undefArrConversion<Response, Data>(conversionFunction: (response: Response) => Data, arr?: Response[]) {
  if (arr !== undefined) return arr.map(conversionFunction);
  return undefined;
}
